export default __webpack_public_path__ + "static/media/fabricLogo.b56cb1b3.jpg";